import { setFocus } from '/helpers/misc'

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Component: `.reveal`
 * Used to contain reveal content
 *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $html = document.querySelector('html')
const $reveal = document.querySelector('.reveal')
const $body = document.querySelector('.reveal .body')

const $fReveal = $($reveal)

export default {

	$body,

	open(options) {
		options = options || {}

		$html.classList.remove('header-up')
		$fReveal.foundation('open')
		if (options.classes) {
			_.each(options.classes, className => $reveal.classList.add(className))
		}

		setFocus($reveal)

		$(document).on('closed.zf.reveal', function() {
			$fReveal.foundation('close')
			if (options.classes) {
				_.each(options.classes, className => $reveal.classList.remove(className))
			}
			if (options.onClose) {
				options.onClose(options.payload)
			}
			$(document).off('closed.zf.reveal')
		})

	},

}
